module.exports = __webpack_public_path__ + "img/12_85.487e6182.png";